export interface Category {
  uuid: string;
  displayName: string;
}

export interface ApiCategory {
  uuid: string;
  full_name: string;
  name: string;
  root_uuid: string;
  root_slug: string;
  slug: string;
  collection_title: string;
  listable: string;
  _links: object;
}

export function sortCategories(categories: ApiCategory[]): ApiCategory[] {
  return categories.sort((a, b) => {
    return a.full_name.toLowerCase().localeCompare(b.full_name.toLowerCase());
  });
}

export function buildCategoryList(categories: ApiCategory[]): Category[] {
  return sortCategories(categories).map((cat) => ({
    uuid: cat.uuid,
    displayName: cat.full_name.replace(/\//g, '>'),
  }));
}

export function findCategoryForDisplayName(categories: Category[], categoryName: string): Category {
  if (!categories || categories.length === 0 || !categoryName) return null;
  return categories.find(cat => String(cat.displayName) === String(categoryName));
}

export function findCategoriesForUUIDs(categories: Category[], uuids: string[]): Category[] {
  if (!categories || categories.length === 0 || !uuids) return [];
  return categories.filter(cat => uuids.includes(cat.uuid));
}

export function removeCategoryWithUUID(categories: Category[], uuid: string): Category[] {
  if (!categories || categories.length === 0 || !uuid) return (categories || []);
  return categories.filter(c => c.uuid !== uuid);
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shipping_profiles/category_data.ts